import { injectable } from "inversify";
import { Bad, OkVal } from "@leavy/result";
import { UserRegistration } from "@/modules/registration/model";

@injectable()
export abstract class RegistrationService {
    abstract register(registration: UserRegistration): Promise<OkVal<{ id: string }> | Bad<"EMAIL_TAKEN" | "PHONE_TAKEN">>;
}
